<template>
  <div style="width: 100%">
    <div style="width: 100%" v-for="(value, name, key) in data" :key="key">
      <div style="width: 100%">
        <v-card-title>{{ t({s: name, component: 'Information'}) }}</v-card-title>
      </div>
      <div style="width: 100%" v-for="(category, key) in value" :key="key">
        <Card :data="category.files" :type="category.type" :language="category.language"/>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Information/Card'

export default {
  name: 'InformationSection',
  components: { Card },
  props: {
    data: Object[{
      files: Array[{
        tag: String,
        title: String
      }],
      language: String,
      type: String
    }]
  }
}
</script>

<style scoped>@import './styles.css';</style>
